export default "__VITE_ASSET__DoMewkf3__"